import { render, staticRenderFns } from "./EPIC.vue?vue&type=template&id=7b8d035e"
import script from "./EPIC.vue?vue&type=script&lang=js"
export * from "./EPIC.vue?vue&type=script&lang=js"
import style0 from "./EPIC.vue?vue&type=style&index=0&id=7b8d035e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports